import * as PropTypes from "prop-types";
import React from "react";

import Button from "../Button";
import { getAutomationDataAttr } from "../../../utils/automationUtils";

import "./styles.scss";

export const LinkIconColor = {
  PURPLE: "purple",
  TEAL: "teal",
};

const LinkIcon = ({ color, icon, label, onClick, testId }) => {
  return (
    <Button className={`LinkIcon ${color}`} {...getAutomationDataAttr(testId)} onClick={onClick}>
      <div className={`LinkIcon--icon ${color}`}>{icon}</div>
      <p className="LinkIcon--label">{label}</p>
    </Button>
  );
};

LinkIcon.propTypes = {
  color: PropTypes.oneOf(Object.values(LinkIconColor)).isRequired,
  icon: PropTypes.element.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

LinkIcon.defaultProps = {
  color: undefined,
  icon: undefined,
  label: "",
  onClick: () => {},
};

export default LinkIcon;
